import { LINK_MASS_MESSAGING_BEST_PRACTICES_GUIDELINES } from 'shared/constants/links'
import { Alert } from 'shared/ui'
import { type IAlert, type IAlertButtonAction, type IAlertLinkAction } from 'shared/ui/Alert/types'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { openIntercomNewMessage } from 'entities/Intercom'

type IBroadcastErrorAlertProps = {
  isBottomActions?: boolean
  failed_reason?: string | null
}

export const BroadcastErrorAlert = ({
  isBottomActions,
  failed_reason,
}: IBroadcastErrorAlertProps) => {
  const isInvalidLink = failed_reason === 'invalid_link'

  let info: Partial<IAlert> = {
    title: 'An error with your contacts or CRM connection was encountered',
    desc: 'Please validate your contacts and try again.',
  }
  if (failed_reason === 'Selected Hubspot list does not exist') {
    info = {
      title: 'Selected HubSpot list does not exist',
    }
  }

  if (isInvalidLink) {
    info = {
      title: 'Suspicious content detected',
      desc: 'Your link has been flagged as spam. If you believe this is an error, contact support for assistance.',
    }
  }

  const handleOpenIntercomWidget = () => {
    openIntercomNewMessage()

    modalStore.closeAllModals()
  }

  const action = (): IAlertButtonAction | IAlertLinkAction => {
    if (isInvalidLink) {
      return {
        variant: 'button',
        type: 'primary',
        text: 'Support',
        onClick: handleOpenIntercomWidget,
      }
    }

    return {
      variant: 'link',
      type: 'primary',
      text: 'Learn more',
      link: LINK_MASS_MESSAGING_BEST_PRACTICES_GUIDELINES,
    }
  }

  return (
    <Alert
      item={{
        type: 'alert',
        ...info,
      }}
      rightActions={!isBottomActions ? [action()] : undefined}
      actions={isBottomActions ? [action()] : undefined}
    />
  )
}
